import { CONFIGURACION_SERVICIOS, CONFIGURACION_MEMBRESIAS, CONFIGURACION_PAQUETES } from '../actions/types';

const initialState = {
    servicios: {
        listado: [],
        detalles: null
    }, 
    membresias: {
        listado: [],
        detalles: null
    }, 
    paquetes: {
        listado: [],
        detalles: null
    }
};

export default (state = initialState, action) => {

    const { type, payload } = action;

    switch ( type ) {
        case CONFIGURACION_SERVICIOS.BUSCAR:
            return {
                ...state,
                servicios: {
                    ...state.servicios, 
                    listado: payload
                }
            };

        case CONFIGURACION_SERVICIOS.AGREGAR:
            let servicios_agregar = state.servicios.listado;

            servicios_agregar = [
                ...servicios_agregar, payload
            ];

            servicios_agregar.sort(function (a, b) {
                if (a.nombre > b.nombre) {
                    return 1;
                }
                if (a.nombre < b.nombre) {
                    return -1;
                }
                return 0;
            });

            return {
                ...state, 
                servicios: {
                    ...state.servicios, 
                    listado: servicios_agregar
                }
            };

        case CONFIGURACION_SERVICIOS.DETALLES:
            return {
                ...state,
                servicios: {
                    ...state.servicios, 
                    detalles: payload
                }
            };

        case CONFIGURACION_SERVICIOS.EDITAR:
            let servicios_editar = state.servicios.listado;

            servicios_editar = servicios_editar.map(servicio => servicio._id === payload._id ? payload : servicio);

            servicios_editar.sort(function (a, b) {
                if (a.nombre > b.nombre) {
                    return 1;
                }
                if (a.nombre < b.nombre) {
                    return -1;
                }
                return 0;
            });

            return {
                ...state, 
                servicios: {
                    ...state.servicios, 
                    listado: servicios_editar
                }
            };

        case CONFIGURACION_SERVICIOS.ELIMINAR:
            return {
                ...state, 
                servicios: {
                    ...state.servicios, 
                    listado: state.servicios.listado.filter( servicio => servicio._id !== payload.id )
                }
            };

        case CONFIGURACION_MEMBRESIAS.BUSCAR:
            return {
                ...state,
                membresias: {
                    ...state.membresias, 
                    listado: payload
                }
            };

        case CONFIGURACION_MEMBRESIAS.AGREGAR:
            let membresias_agregar = state.membresias.listado;

            membresias_agregar = [
                ...membresias_agregar, payload
            ];

            membresias_agregar.sort(function (a, b) {
                if (a.nombre > b.nombre) {
                    return 1;
                }
                if (a.nombre < b.nombre) {
                    return -1;
                }
                return 0;
            });

            return {
                ...state, 
                membresias: {
                    ...state.membresias, 
                    listado: membresias_agregar
                }
            };

        case CONFIGURACION_MEMBRESIAS.DETALLES:
            return {
                ...state,
                membresias: {
                    ...state.membresias, 
                    detalles: payload
                }
            };

        case CONFIGURACION_MEMBRESIAS.EDITAR:
            let membresias_editar = state.membresias.listado;

            membresias_editar = membresias_editar.map(membresia => membresia._id === payload._id ? payload : membresia);

            membresias_editar.sort(function (a, b) {
                if (a.nombre > b.nombre) {
                    return 1;
                }
                if (a.nombre < b.nombre) {
                    return -1;
                }
                return 0;
            });

            return {
                ...state, 
                membresias: {
                    ...state.membresias, 
                    listado: membresias_editar
                }
            };

        case CONFIGURACION_MEMBRESIAS.ELIMINAR:
            return {
                ...state, 
                membresias: {
                    ...state.membresias, 
                    listado: state.membresias.listado.filter( membresia => membresia._id !== payload.id )
                }
            };

        case CONFIGURACION_PAQUETES.BUSCAR:
            return {
                ...state,
                paquetes: {
                    ...state.paquetes, 
                    listado: payload
                }
            };

        case CONFIGURACION_PAQUETES.AGREGAR:
            let paquetes_agregar = state.paquetes.listado;

            paquetes_agregar = [
                ...paquetes_agregar, payload
            ];

            paquetes_agregar.sort(function (a, b) {
                if (a.nombre > b.nombre) {
                    return 1;
                }
                if (a.nombre < b.nombre) {
                    return -1;
                }
                return 0;
            });

            return {
                ...state, 
                paquetes: {
                    ...state.paquetes, 
                    listado: paquetes_agregar
                }
            };

        case CONFIGURACION_PAQUETES.DETALLES:
            return {
                ...state,
                paquetes: {
                    ...state.paquetes, 
                    detalles: payload
                }
            };

        case CONFIGURACION_PAQUETES.EDITAR:
            let paquetes_editar = state.paquetes.listado;

            paquetes_editar = paquetes_editar.map(paquete => paquete._id === payload._id ? payload : paquete);

            paquetes_editar.sort(function (a, b) {
                if (a.nombre > b.nombre) {
                    return 1;
                }
                if (a.nombre < b.nombre) {
                    return -1;
                }
                return 0;
            });

            return {
                ...state, 
                paquetes: {
                    ...state.paquetes, 
                    listado: paquetes_editar
                }
            };

        case CONFIGURACION_PAQUETES.ELIMINAR:
            return {
                ...state, 
                paquetes: {
                    ...state.paquetes, 
                    listado: state.paquetes.listado.filter( paquete => paquete._id !== payload.id )
                }
            };
    
        default:
            return state;
    }
}